import {serverTime} from "@atg-shared/server-time";

import {parseDateTimestamp} from "./parseDateTimestamp";

export const now = () => parseDateTimestamp(serverTime());
